/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ItemImageVo
 */
export interface ItemImageVo {
    /**
     * 
     * @type {string}
     * @memberof ItemImageVo
     */
    url?: string;
}

/**
 * Check if a given object implements the ItemImageVo interface.
 */
export function instanceOfItemImageVo(value: object): value is ItemImageVo {
    return true;
}

export function ItemImageVoFromJSON(json: any): ItemImageVo {
    return ItemImageVoFromJSONTyped(json, false);
}

export function ItemImageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemImageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ItemImageVoToJSON(json: any): ItemImageVo {
    return ItemImageVoToJSONTyped(json, false);
}

export function ItemImageVoToJSONTyped(value?: ItemImageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

